// React
import React from 'react'
import classNames from 'classnames'
// External libs
import { get } from 'lodash'
//Styles
import useStyles from './CustomReadOnlyPrefixPhone.styles'

const CustomReadOnlyPrefixPhone = ({ classes, flag, prefixNumber }) => {
  const componentClasses = useStyles()
  return (
    <div
      className={classNames(
        get(componentClasses, 'root', null),
        get(classes, 'root', null),
      )}
    >
      <img className={componentClasses.flag} alt='countryFlag' src={flag} />
      <div className={classNames(componentClasses.prefixNumber)}>
        {prefixNumber}
      </div>
    </div>
  )
}

CustomReadOnlyPrefixPhone.defaultProps = {
  classes: {},
  flag: '',
  prefixNumber: '',
}

export default CustomReadOnlyPrefixPhone
